import { reactive } from "vue";

export function useDyslexicFont() {
    const state = reactive({
        isDyslexicFontActive: false,
        fontForDyslexic: "OpenDyslexic",
        zoomWrapper: "#zoomWrapper",
    });

    function applyDyslexicFont(node) {
        if (!node) return;

        const fontToUse = state.isDyslexicFontActive ? state.fontForDyslexic : "";
        if (node.hasChildNodes()) {
            node.childNodes.forEach((childNode) => applyDyslexicFont(childNode));
        }
        if (node.nodeType === 3 && node.nodeValue.trim() !== "") {
            node.parentElement.style.fontFamily = fontToUse;
        }
    }

    function setDyslexicFontState(isActive) {
        state.isDyslexicFontActive = !!isActive;
        applyDyslexicFont(document.querySelector(state.zoomWrapper));
    }

    function reset() {
        setDyslexicFontState(false);
    }

    function applyFromProfile(entry) {
        if (entry.isFontActive) {
            setDyslexicFontState(true);
        }
    }

    return { state, setDyslexicFontState, applyDyslexicFont, reset, applyFromProfile };
}
